import { Button } from "@mui/material";
import {
  CustomTable,
  FilterGroupComponent,
  OverflowText,
  SnackbarComponent,
} from "components";
import { useGetClientList } from "./service/ClientManagementService";
import { useCallback, useMemo, useState } from "react";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import CreateEditClientModal from "./components/CreateEditClientModal";
import { emptyToastMessage } from "consts/common";
import storage from "services/storage";
import "./ClientManagementPage.css";
import { capitalize } from "lodash";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "components/snackbar/SnackbarContext";

const ClientManagementPage = () => {
  const navigate = useNavigate();
  const [createEditModal, setCreateEditModal] = useState({ open: false });
  const { message, setMessage } = useSnackbar();

  const headCells = [
    {
      id: "name",
      label: <p className='text-xs'>Client Name</p>,
    },
    {
      id: "industry_name",
      label: <p className='text-xs'>Industry</p>,
    },
    {
      id: "status",
      label: <p className='text-xs'>Status</p>,
    },
    {
      id: "year_established",
      label: <p className='text-xs'>Listing Year</p>,
    },
    {
      id: "no_of_users",
      label: <p className='text-xs'>Number of Accounts</p>,
    },
    {
      id: "actions",
      label: <p className='text-xs'>Actions</p>,
    },
  ];

  const { response: clientListResp, refetch } = useGetClientList({
    enableAutoFetchByParams: true,
  });

  const handleOpenCreateEditModal = (id) => {
    setCreateEditModal({ open: true, id });
  };
  const bodyCells = useMemo(
    () =>
      clientListResp?.data?.companies?.map((el) => ({
        ...el,
        name: <OverflowText text={el?.name} />,
        status: capitalize(el?.status),
        actions: (
          <div className='flex align-middle gap-2'>
            <RemoveRedEyeOutlinedIcon
              className='cursor-pointer'
              onClick={() => navigate(`/client-management/${el?.company_id}`)}
              sx={{ color: "#146BDE" }}
            />
            {storage.getItem("role")?.includes("ADMIN") && (
              <EditOutlinedIcon
                className='cursor-pointer'
                onClick={() => handleOpenCreateEditModal(el?.company_id)}
                sx={{ color: "#FBD603" }}
              />
            )}
          </div>
        ),
      })),
    [clientListResp, navigate],
  );

  const handleCloseCreateEditModal = useCallback(() => {
    setCreateEditModal({ open: false });
    refetch();
  }, [refetch]);

  return (
    <div className='client-management-page section h-full'>
      <div className='flex flex-row mb-5 justify-between'>
        <FilterGroupComponent
          showStatusFilter={false}
          showTypeFilter={false}
          showDateRangePicker={false}
          searchPlaceholder='Search by name'
          searchParamsQueryKey='name'
        />
        {storage.getItem("role")?.includes("ADMIN") && (
          <Button
            onClick={() => handleOpenCreateEditModal()}
            variant='contained'
            className='!bg-[#556FB5]'
          >
            Create New Client
          </Button>
        )}
      </div>
      <CustomTable
        id='client-management-list-table'
        emptyImgSrc='/images/empty-client.svg'
        headCells={headCells}
        bodyCells={bodyCells ?? []}
        bodyCellKey='name'
        total={clientListResp?.data?.total}
      />

      {createEditModal?.open && (
        <CreateEditClientModal
          modalProps={{
            open: createEditModal?.open,
            onClose: () => handleCloseCreateEditModal(),
          }}
          id={createEditModal?.id}
          onClose={handleCloseCreateEditModal}
        />
      )}

      {message.desc && (
        <SnackbarComponent
          labelTitle={message?.title}
          labelMessage={message?.desc}
          type={message?.type}
          onClose={() => setMessage(emptyToastMessage)}
          duration={5000}
        />
      )}
    </div>
  );
};

export default ClientManagementPage;
